'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopRegionStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = function base(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    font-family: ' + fontFamily + ';\n  ';
};

var TopRegionStyled = exports.TopRegionStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TopRegionStyled'
})(['width:100%;display:flex;flex-direction:column;flex-shrink:0;box-sizing:border-box;', ';'], base);

TopRegionStyled.displayName = 'TopRegionStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-app/dist/TopRegion/styles/TopRegionStyled.js
// module id = 538
// module chunks = 0